import React from 'react'
import {useTranslation} from "react-i18next";
import ConfirmModal from 'components/common/ConfirmModal';

const WorkRecodeCloseModal = ({ isOpen, setIsOpen }) => {
  const { t } = useTranslation()

  return (
    <ConfirmModal
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      title={t('근무기록 마감')}
      description={t('해당 근무기록은 마감되어') + ' ' +t('수정하실 수 없습니다.')}
      confirmText={t('확인')}
      onConfirm={() => setIsOpen(false)}
      hideCancel={true}
    />
  )
}

export default React.memo(WorkRecodeCloseModal)